import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { SuccessfulWithIconPopupComponent } from '../libs/shared/components/successful-with-icon-popup/successful-with-icon-popup.component';
import { SuccessPopupModel } from '../models/ui.model';
import {
    ConfirmationPopupInterface,
    ConfirmationPopupModel,
} from '../libs/shared/components/confirmation-popup/confirmation-popup.model';
import { Observable } from 'rxjs';
import { openConfirmationDialog } from '../libs/shared/components/confirmation-popup/confirmation-popup.component';
import {
    ReminderPopupInterface,
    ReminderPopupModel,
} from '../libs/shared/components/reminder-popup/reminder-popup.model';
import { openReminderDialog } from '../libs/shared/components/reminder-popup/reminder-popup.component';
import {
    AskPodPopupComponent,
    openAskPodDialog,
} from '../libs/shared/components/askpod-popup/askpod-popup.component';
import { AskPodPopupInterface } from '../libs/shared/components/askpod-popup/askpod-popup.model';
import {
    AskPodDowntimePopupComponent,
    openAskPodDowntimeDialog,
} from '../libs/shared/components/askpod-downtime-popup/askpod-downtime-popup.component';
import { AskPodDowntimePopupInterface } from '../libs/shared/components/askpod-downtime-popup/askpod-downtime-popup.model';
import {
    AskPodTrialEndedPopupComponent,
    openAskPodTrialEndedDialog,
} from '../libs/shared/components/askpod-trial-ended-popup/askpod-trial-ended-popup.component';
import { AskPodTrialEndedPopupInterface } from '../libs/shared/components/askpod-trial-ended-popup/askpod-trial-ended-popup.model';

@Injectable({ providedIn: 'root' })
export class DialogService {
    constructor(private dialogService: MatDialog) {}

    openSuccessfulPopup(data: SuccessPopupModel): MatDialogRef<SuccessfulWithIconPopupComponent> {
        const defaultDialogConfig = this.getDefaultDialogConfig();
        defaultDialogConfig.data = { ...data };
        defaultDialogConfig.autoFocus = false;

        return this.dialogService.open(SuccessfulWithIconPopupComponent, defaultDialogConfig);
    }

    showConfirmationPopup(data: ConfirmationPopupInterface): Observable<boolean> {
        const confirmationModel = new ConfirmationPopupModel(data);

        return openConfirmationDialog(this.dialogService, confirmationModel);
    }

    showReminderPopup(data: ReminderPopupInterface): Observable<boolean> {
        const confirmationModel = new ReminderPopupModel(data);

        return openReminderDialog(this.dialogService, confirmationModel);
    }

    openAskPodPopup(data?: AskPodPopupInterface): MatDialogRef<AskPodPopupComponent> {
        return openAskPodDialog(this.dialogService, data);
    }

    openAskPodDowntimePopup(
        data?: AskPodDowntimePopupInterface
    ): MatDialogRef<AskPodDowntimePopupComponent, boolean> {
        return openAskPodDowntimeDialog(this.dialogService, data);
    }

    openAskPodTrialEndedPopup(
        data?: AskPodTrialEndedPopupInterface,
    ): MatDialogRef<AskPodTrialEndedPopupComponent, boolean> {
        return openAskPodTrialEndedDialog(this.dialogService, data);
    }

    private getDefaultDialogConfig(): MatDialogConfig {
        return {
            autoFocus: true,
            maxWidth: '80vw',
            maxHeight: '80vh',
            enterAnimationDuration: '250ms',
            exitAnimationDuration: '250ms',
            disableClose: true,
        };
    }
}
